import React from 'react';
import { ExpandArrowIcon, XIcon } from '../../icons';
var MuiAutocomplete = {
    /* put your new default props here */
    popupIcon: React.createElement(ExpandArrowIcon, { size: "small" }),
    closeIcon: React.createElement(XIcon, { size: "small" }),
    // by default, our Autocompletes should highlight the first option
    autoHighlight: true,
    // Our Autocompletes open on focus by default.
    openOnFocus: true,
};
export default MuiAutocomplete;
//# sourceMappingURL=MuiAutocomplete.js.map